import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const maintenance = {
  namespaced: true,
  state: () => ({
    // Set to true to activate maintenance mode immediately (static toggle)
    isActive: false,
    // Optional message to display on the maintenance page
    message: "",
    // Optional estimated completion time (e.g., "March 5, 2026 at 10:00 PM")
    estimatedTime: "",
  }),
  mutations: {
    SET_MAINTENANCE(state, payload) {
      state.isActive = payload.isActive ?? state.isActive;
      state.message = payload.message ?? state.message;
      state.estimatedTime = payload.estimatedTime ?? state.estimatedTime;
    },
    TOGGLE_MAINTENANCE(state, value) {
      state.isActive = value;
    },
  },
  actions: {
    /**
     * Enable maintenance mode with optional message/estimated time.
     * Usage: store.dispatch('maintenance/enableMaintenance', { message: '...', estimatedTime: '...' })
     */
    enableMaintenance({ commit }, payload = {}) {
      commit("SET_MAINTENANCE", {
        isActive: true,
        message: payload.message || "",
        estimatedTime: payload.estimatedTime || "",
      });
    },

    /**
     * Disable maintenance mode.
     */
    disableMaintenance({ commit }) {
      commit("SET_MAINTENANCE", {
        isActive: false,
        message: "",
        estimatedTime: "",
      });
    },

    /**
     * Check maintenance status from API (optional).
     * If your backend provides a maintenance status endpoint, configure VITE_API_URL
     * and this action will call GET /api/maintenance/status.
     *
     * Expected API response: { is_active: bool, message: string, estimated_time: string }
     *
     * If no API is available, this simply resolves with the current local state.
     */
    async checkMaintenanceStatus({ commit, state }) {
      try {
        const response = await axios.get(`${API_URL}/api/maintenance/status`);
        const data = response.data;
        commit("SET_MAINTENANCE", {
          isActive: data.is_active ?? false,
          message: data.message ?? "",
          estimatedTime: data.estimated_time ?? "",
        });
        return state.isActive;
      } catch (error) {
        // If API call fails, keep current state
        console.warn("Maintenance status check failed, using local state:", error.message);
        return state.isActive;
      }
    },
  },
  getters: {
    isMaintenanceActive: (state) => state.isActive,
    maintenanceMessage: (state) => state.message,
    estimatedTime: (state) => state.estimatedTime,
  },
};

export default maintenance;
